import React from 'react';
import { createPortal } from 'react-dom';

import { LinearProgress } from '@mui/material';

import useIsMounted from 'hooks/useIsMounted';

const rootStyles = {
  position: 'fixed',
  width: '100%',
  zIndex: 999,
};

export default () => {
  const portalTarget = document.querySelector('#loader-root');
  const isMounted = useIsMounted();

  return (
    isMounted && createPortal(<LinearProgress color="primary" sx={rootStyles} />, portalTarget)
  );
};
